
import * as React from 'react';
import Button from '../../Button';
import {DropdownMenu} from '../../DropdownMenu';
import { IDropdownMenuOption } from '../../DropdownMenu/DropdownMenu';
import { Modal } from '../../Modal';
import { ImageFileTypes } from '../../../infrastructure/ImageFileTypes'
import { ISeedCategory } from '../../../infrastructure/interfaces'
import './TechSheetCreatorModal.css';

export interface TechSheetCreatorProps {
  show: any;
  onClose: any;
  seedCategories?: ISeedCategory[];
  onSubmit(techSheetName: string[], seedCategory: ISeedCategory, formData: FormData[]): void;
}

export interface TechSheetCreatorState {
  techSheetNames: string[];
  hasRequiredFields: boolean;
  imageFormData?: FormData[];
  selectedCategory?: ISeedCategory;
}

export default class TechSheetCreatorModal extends React.Component<TechSheetCreatorProps, TechSheetCreatorState> {

  constructor(props: TechSheetCreatorProps) {
    super(props);
    this.state = {
      techSheetNames: [],
      imageFormData: undefined,
      hasRequiredFields: false,
      selectedCategory: undefined,
    };
  }

  validateInput() {
    const hasValidImages = this.state.imageFormData != undefined
    const hasValidCategory = this.state.selectedCategory != undefined
    const hasImageFormData = this.state.imageFormData != undefined && this.state.imageFormData.length > 0
    const hasValidSheetNames = this.state.techSheetNames.length > 0

    this.setState({
        hasRequiredFields: hasValidImages && hasValidCategory && hasImageFormData && hasValidSheetNames
    })
}

  closeModal() {
      this.setState({
        techSheetNames: [],
        imageFormData: undefined
      });
      this.props.onClose();
  }

  handleSeedCategoryChange(category: ISeedCategory) {
    this.setState({
        selectedCategory: category
    }, () => this.validateInput());
  }

  handleInputTextChange(e: any, sheetNameIndex: number) {
    let techNameClone = this.state.techSheetNames
    techNameClone.splice(sheetNameIndex, 1, e.target.value)
   
    this.setState({
      techSheetNames: techNameClone
    });

  }

  handleChange(selectorFiles: FileList | null)
  {
    if (selectorFiles != null) {
      var fileNames: string[] = [];
      var formsData: FormData[] = [];

      for (var key in selectorFiles) {
        if (selectorFiles.hasOwnProperty(key) && selectorFiles[key] instanceof File) {
          let name = selectorFiles[key].name;    
          fileNames.push(name.split('.').slice(0, -1).join('.'));

          var formData = new FormData();
          formData.set(ImageFileTypes.TECH_SHEET, selectorFiles[key]);
          formsData.push(formData);
        }
      }

      this.setState({
        imageFormData: formsData,
        techSheetNames: fileNames
      }, () => this.validateInput());
    }
  }

  render() {

    const nonNilCategories = this.props.seedCategories ? this.props.seedCategories : []
    const nonNilTechSheetNames = this.state.techSheetNames.length > 0 ? this.state.techSheetNames : []

    const categoryOptionsList: IDropdownMenuOption[] = nonNilCategories.map((category) => (
        {
        title: category.name,
        onClick: () => { 
          this.handleSeedCategoryChange(category);
        }
      })
    );

    return (
        <Modal show={this.props.show}
          onClose={() => {this.closeModal();}}
        >
            <Modal.Header>
                <Modal.Title>
                    <h5>
                        {'Upload Tech Sheets'}
                    </h5>
                </Modal.Title>
                <Button bsClass="close" onClick={() => {this.closeModal();}}></Button>
            </Modal.Header>
            <Modal.Body>
                <div className="techSheetInputContainer">
                    <div className="techSheetInputRow">
                        <div>
                          <b><label className="techSheetInputLabel">Seed Category: </label></b>
                        </div>
                        <div>
                            <DropdownMenu
                                title={ this.state.selectedCategory ? this.state.selectedCategory.name : "Select a Seed Category" }
                                options={categoryOptionsList}
                                extraWide={true}
                            />
                        </div>
                    </div>
                    <div className="techSheetInputRow">
                        <label className="techSheetInfoLabel">
                            Image (JPEG, 8.5"x11")
                        </label>
                        <input type="file"
                            className="filepond"
                            multiple data-max-files="50"
                            accept="image/jpg, image/jpeg, image/png"
                            onChange={(e) => this.handleChange(e.target.files)} />
                    </div>

                    
                    {nonNilTechSheetNames.map((name, index) => {
                      return <div key={index}  className="techSheetInputRow-results"> 
                        <input
                        maxLength={40}
                        value={name}
                        onChange={e => {
                            this.handleInputTextChange(e, index);}}/> 
                      </div>
                    })}
                    

                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsClass="cancel" onClick={() => {this.closeModal();}}>
                    Cancel
                </Button>
                <Button
                    bsClass="primary"
                    disabled={!this.state.hasRequiredFields}
                    onClick={() => {
                      if ((this.state.imageFormData != undefined) && (this.state.selectedCategory != undefined && this.state.techSheetNames.length > 0)){
                        this.props.onSubmit(this.state.techSheetNames, this.state.selectedCategory, this.state.imageFormData);
                        this.setState({
                          imageFormData: undefined,
                          hasRequiredFields: false,
                          selectedCategory: undefined,
                          techSheetNames: [],
                        })
                      }
                    }}
                >
                    Upload
                </Button>
            </Modal.Footer>
        </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/TechSheetCreatorModal/TechSheetCreatorModal.tsx